import { Modal, ModalHeader, ModalBody, Button, ModalFooter } from "reactstrap";
import { FormattedMessage } from "react-intl";

export default function PromtGeneric({
  onProceed,
  toggle,
  isOpen,
  title,
  text,
  btnText = "Continue",
  danger,
}) {
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader>{title}</ModalHeader>
      <ModalBody>{text}</ModalBody>
      <ModalFooter>
        <Button onClick={toggle} color="secondary" outline>
          <FormattedMessage id="Cancel" />
        </Button>
        <Button
          onClick={() => onProceed()}
          color={danger ? "danger" : "success"}
          outline
        >
          <FormattedMessage id={btnText} />
        </Button>
      </ModalFooter>
    </Modal>
  );
}
